import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { applicationsActivationsValidateSearchSchema } from '../../../common/applicationsActivations/applicationsActivationsValidateSearchSchema';
import { clientApplicationsRoute } from '../route';

export const clientActivationsHistoryRoute = createRoute({
	getParentRoute: () => clientApplicationsRoute,
	path: '/activations-history',
	component: lazyRouteComponent(
		() => import('./ClientActivationsHistoryPage'),
		'ClientActivationsHistoryPage',
	),
	validateSearch: applicationsActivationsValidateSearchSchema,
});
